import { Flex, Center, Text, FlexProps } from '@chakra-ui/react';
import { CustomIcon } from 'components';
import React, { memo } from 'react';

interface IProps extends FlexProps {
  text: String;
}

const WarningMessageComponent: React.FC<IProps> = ({ text, ...props }) => {
  return (
    <Flex
      p="16px"
      borderRadius="4px"
      border="2px solid"
      borderColor="brand.red200"
      backgroundColor="brand.warning"
      {...props}
    >
      <Center color="brand.red200" mr="20px" h="100%">
        <CustomIcon icon="info_outline" size="20px" color="brand.red200" $noSphere />
      </Center>
      <Center w="100%" h="100%">
        <Text fontSize="14px">{text}</Text>
      </Center>
    </Flex>
  );
};

export const WarningMessage = memo(WarningMessageComponent);
